import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsStar, BsStarFill } from "react-icons/bs";
import config from "../../config";

const FilterSection = ({ title, children }) => (
  <div className="border-bottom pb-4 mb-4">
    <h5>{title}</h5>
    <div className="d-grid gap-2">{children}</div>
  </div>
);

const ProductFilter = ({ filters, updateFilters, categoryId }) => {
  const [min, setMin] = useState(filters.minPrice || 0);
  const [max, setMax] = useState(filters.minPrice || 0);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(
    filters.categories || []
  );
  const [selectedRatings, setSelectedRatings] = useState(filters.ratings || []);

  const getCategories = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/all/category`);
      setCategories(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const handleInputChange = (inputValue, param) => {
    if (param === "min") {
      setMin(inputValue);
    } else {
      setMax(inputValue);
    }
  };

  const handleCategoryChange = (categoryId) => {
    setSelectedCategories((prevCategories) =>
      prevCategories.includes(categoryId)
        ? prevCategories.filter((id) => id !== atob(decodeURIComponent(categoryId)))
        : [...prevCategories, categoryId]
    );
  };

  const handleRatingChange  = (rating) => {
    setSelectedRatings((prevRatings) => 
      prevRatings.includes(rating)
        ? prevRatings.filter((r) => r !== rating)
        : [...prevRatings, rating]
    
    )
  }
  
  useEffect(() => {
    updateFilters({
      categories: selectedCategories,
      ratings: selectedRatings
    });
  }, [selectedCategories, selectedRatings]);
  

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    updateFilters({ minPrice: min, maxPrice: max });
  };

  return (
    <div className="col-lg-3 col-xxl-2">
      <div className="navbar-expand-lg mb-5">
        <div className="d-grid">
          <button
            type="button"
            className="navbar-toggler btn btn-secondary mb-3"
            data-bs-toggle="collapse"
            data-bs-target="#navbarVerticalNavMenu"
            aria-label="Toggle navigation"
            aria-expanded="false"
            aria-controls="navbarVerticalNavMenu"
          >
            <span className="d-flex justify-content-between align-items-center">
              <span className="text-dark">Filter </span>
              <span className="navbar-toggler-default">
                <i className="bi-list"></i>
              </span>
              <span className="navbar-toggler-toggled">
                <i className="bi-x"></i>
              </span>
            </span>
          </button>
        </div>
        <div id="navbarVerticalNavMenu" className="collapse navbar-collapse">
          <div className="w-100">
            <form onSubmit={handleFilterSubmit}>
              <FilterSection title={"Price range"}>
                <div className="collapse show">
                  <div className="d-flex gap-2">
                    <div className="input-group">
                      <input
                        placeholder="Min"
                        type="number"
                        className="form-control"
                        onChange={(e) =>
                          handleInputChange(e.target.value, "min")
                        }
                      />
                      <input
                        placeholder="Max"
                        type="number"
                        className="form-control"
                        onChange={(e) =>
                          handleInputChange(e.target.value, "max")
                        }
                      />
                    </div>
                    <button
                      // onClick={() => handleFiltering(min, max)}
                      type="submit"
                      className="btn btn-primary px-3 btn-sm"
                    >
                      Go
                    </button>
                  </div>
                </div>
              </FilterSection>

              { !categoryId && <FilterSection title={"Categories"}>
                {categories.length === 0
                  ? "No category found"
                  : categories.map((category) => (
                      <Checkbox
                        key={category.id}
                        id={`category-${category.id}`}
                        label={category.name}
                        checked={selectedCategories.includes(category.id)}
                        onChange={() => handleCategoryChange(category.id)}
                      />
                    ))}
              </FilterSection>}

              <FilterSection title={"Rating"}>
              {[1, 2, 3, 4, 5].map((star) => (
                  <Checkbox
                    key={`rating-${star}`}
                    id={`rating-${star}`}
                    label={<RatingLabel stars={star} />}
                    checked={selectedRatings.includes(star)}
                    onChange={() => handleRatingChange(star)}
                  />
                ))}
                {/* <Checkbox
                  id="1starCheckbox"
                  label={<RatingLabel stars={1} />}
                />
                <Checkbox
                  id="2starCheckbox"
                  label={<RatingLabel stars={2} />}
                />
                <Checkbox
                  id="3starCheckbox"
                  label={<RatingLabel stars={3} />}
                />
                <Checkbox
                  id="4starCheckbox"
                  label={<RatingLabel stars={4} />}
                />
                <Checkbox
                  id="5starCheckbox"
                  label={<RatingLabel stars={5} />}
                /> */}
              </FilterSection>

              <div className="d-grid">
                <button type="button" className="btn btn-white btn-transition">
                  Clear all
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductFilter;

const Checkbox = ({ id, label, checked, onChange }) => (
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id={id}
      defaultChecked={checked}
      onChange={(e) => onChange(e.target.value)}
    />
    <label className="form-check-label d-flex" htmlFor={id}>
      {label}
    </label>
  </div>
);

const RatingLabel = ({ stars, count }) => {
  const fullStars = Array(stars).fill(<BsStarFill className="text-warning" />);
  const emptyStars = Array(5 - stars).fill(<BsStar color="gold#" />);

  const allStars = [...fullStars, ...emptyStars];

  return (
    <div className="d-flex gap-1">
      {allStars.map((star, index) => (
        <span key={index}> {star} </span>
      ))}
    </div>
  );
};

/* <FilterSection title={""} >
              
            </FilterSection> */

/* <FilterSection title="Gender">
              <Checkbox id="menCheckbox" label="Men (73)" checked={true} />
              <Checkbox id="womenCheckbox" label="Women (51)" checked={true} />
            </FilterSection>
            <FilterSection title="Brand">
              <Checkbox id="adidasCheckbox" label="Adidas (16)" />
              <Checkbox id="newBalanceCheckbox" label="New Balance (8)" />
              <Checkbox id="nikeCheckbox" label="Nike (35)" />
              <Checkbox id="fredPerryCheckbox" label="Fred Perry (5)" />
              <Checkbox id="tnfCheckbox" label="The North Face (1)" />
              <div className="collapse" id="collapseBrand">
                <Checkbox id="gucciCheckbox" label="Gucci (5)" />
                <Checkbox id="mangoCheckbox" label="Mango (1)" />
              </div>
              <a
                className="link-sm link-collapse"
                href="#collapseBrand"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="collapseBrand"
              >
                <span className="link-collapse-default">View more</span>
                <span className="link-collapse-active">View less</span>
              </a>
            </FilterSection>
            <FilterSection title="Size">
              <Checkbox id="sizeSCheckbox" label="S (27)" checked={true} />
              <Checkbox id="sizeMCheckbox" label="M (18)" />
              <Checkbox id="sizeLCheckbox" label="L (0)" checked={true} />
              <Checkbox id="sizeXLCheckbox" label="XL (1)" />
              <Checkbox id="sizeXXLCheckbox" label="XXL (2)" />
            </FilterSection>
            <FilterSection title="Category">
              <Checkbox
                id="tshirtCheckbox"
                label="T-shirt (73)"
                checked={true}
              />
              <Checkbox id="shoesCheckbox" label="Shoes (0)" />
              <Checkbox
                id="accessoriesCheckbox"
                label="Accessories (51)"
                checked={true}
              />
              <Checkbox id="topsCheckbox" label="Tops (5)" checked={true} />
              <Checkbox id="bottomCheckbox" label="Bottom (11)" />
              <div className="collapse" id="collapseCategory">
                <Checkbox id="shortsCheckbox" label="Shorts (6)" />
                <Checkbox id="hatsCheckbox" label="Hats (3)" />
                <Checkbox id="socksCheckbox" label="Socks (8)" />
              </div>
              <a
                className="link-sm link-collapse"
                href="#collapseCategory"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="collapseCategory"
              >
                <span className="link-collapse-default">View more</span>
                <span className="link-collapse-active">View less</span>
              </a>
            </FilterSection> */
